import React, { useEffect, useState } from "react";
import { adminGetSettings, adminPutSettings } from "../../lib/api";

const FIELDS = [
  ["brand", "Business name"], ["tagline", "Tagline"], ["whatsapp", "WhatsApp number (with country code)"],
  ["phone", "Phone"], ["email", "Contact email"], ["city", "City"], ["gst", "GST number (optional)"],
];

export default function AdminSettings() {
  const [s, setS] = useState(null);
  const [saved, setSaved] = useState("");
  useEffect(() => { adminGetSettings().then(setS).catch(() => setS({})); }, []);
  if (!s) return <p className="adm-sub">Loading…</p>;
  const save = async () => { const r = await adminPutSettings(s); setS(r); setSaved("Settings saved. Refresh the website to see changes."); setTimeout(() => setSaved(""), 3000); };
  return (
    <div>
      <h1 className="adm-h1">Settings</h1>
      <p className="adm-sub">These details appear across the public website (brand, footer, WhatsApp button).</p>
      <div className="panel" style={{ maxWidth: 560 }}>
        {FIELDS.map(([k, label]) => (
          <div className="field" key={k}><label>{label}</label>
            <input value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} />
          </div>
        ))}
        <button className="adm-btn primary" type="button" onClick={save}>Save settings</button>
        {saved ? <p style={{ color: "var(--ok)", fontWeight: 700, marginTop: 12 }}>{saved}</p> : null}
      </div>
    </div>
  );
}
